import request from 'services/request';

export async function clientsMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/Clients/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
